import axios from "axios";
import { HTTP_STATUS } from "../utils/constants";
import { API_BASE_URL } from "../config/apiConfig";

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT || 10000),
  headers: {
    "Content-Type": "application/json",
  },
});

const authSessionBridge = {
  getAccessToken: () => null,
  refreshAccessToken: async () => null,
  clearAuth: () => {},
};

export const registerAuthSessionHandlers = (handlers = {}) => {
  authSessionBridge.getAccessToken = handlers.getAccessToken || (() => null);
  authSessionBridge.refreshAccessToken =
    handlers.refreshAccessToken || (async () => null);
  authSessionBridge.clearAuth = handlers.clearAuth || (() => {});
};

export const resetAuthSessionHandlers = () => {
  registerAuthSessionHandlers();
};

api.interceptors.request.use((config) => {
  const token = authSessionBridge.getAccessToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === HTTP_STATUS.UNAUTHORIZED &&
      originalRequest &&
      !originalRequest._retry &&
      !originalRequest.url?.includes("/api/v1/auth/refresh")
    ) {
      originalRequest._retry = true;

      try {
        const accessToken = await authSessionBridge.refreshAccessToken();

        if (!accessToken) {
          throw new Error("Unable to refresh access token");
        }

        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
        return api(originalRequest);
      } catch (_refreshError) {
        authSessionBridge.clearAuth();
        // In a SPA, clearAuth triggers state updates that redirect through route guards.
        // Hard reloads via window.location.assign should be avoided to preserve state
        // and prevent reload loops on the login page itself.
      }
    }

    return Promise.reject(error);
  },
);

export default api;
